<div class="whats-new-banner" *ngIf="showBanner$ | async">
    <div class="banner-content">
        <div class="banner-header">
            <h2>{{ 'whatsNewBanner.whatsNewTitleText' | translate }}</h2>
            <button class="close-button" (click)="onDismiss()">
                <span>&times;</span>
            </button>
        </div>
        <div class="features-list">
            <div class="feature-item" *ngFor="let feature of features$ | async">
                <div class="feature-header">
                    <h3>{{ feature.title | translate }}</h3>
                    <span class="version">v{{ feature.version }}</span>
                </div>
                <p>{{ feature.description | translate }}</p>
                <small>{{ formatDate(feature.date) }}</small>
            </div>
        </div>
    </div>
</div>
